export default {
  "Login for users": "Inicio de sesión",
  Login: "Correo electrónico / Teléfono",
  Password: "Contraseña",
  Submit: "Ingresar",
  "Field required": "Campo obligatorio",
  "Auth error 400": "Usuario o contraseña incorrectos",
  "Auth error network":
    "Problema de conexión. Verifique su conexión a internet e intente nuevamente.",
  "Auth error unknown": "Error. Inténtelo de nuevo más tarde.",
  "Login title": "Autenticación | " + process.env.VUE_APP_INSTALL_NAME + "",
  "Not account yet": "¿No tienes una cuenta?",
  "Not account yet about":
    "Puedes crear una cuenta o acceder al modo demo con funcionalidad limitada",
  "Demo-mode": "Modo demo",
  "Let register": "Registro",
  "User Agreement Title":
    "Acuerdo de usuario | " + process.env.VUE_APP_INSTALL_NAME + "",
  "User Agreement": "Acuerdo de usuario",
  "Privacy policy": "Política de privacidad de datos personales",
  "User Agreement About part 1":
    "Al continuar usando el sitio, usted acepta los términos del ",
  "User Agreement About part 2": "acuerdo de usuario.",
  "User Agree": "Acepto",
  "Page not found": "Página no encontrada",
  "Page not found about":
    "Dirección incorrecta o la página ya no existe. Regrese a la página principal",
  "Back to main page": "Volver al inicio",
  "Login for users 2":
    "Obtén acceso completo a las funciones de la plataforma " +
    process.env.VUE_APP_INSTALL_NAME +
    "",
  Step: "Paso",
  "Min 8": "Mínimo 8 caracteres",
  "1 char": "1 letra",
  "1 num": "1 número",
  "Auth access 1": "Acepto ",
  "Auth access 2": "el tratamiento de datos personales",
  "Auth access 3": ", acepto los términos de la ",
  "Auth access 4": "política",
  "Auth access 5": "y",
  "Auth access 6": "acuerdo de usuario",
  "Auth access 7": "recepción de materiales publicitarios e informativos",
  "Have account?": "¿Tienes una cuenta?",
  "To next": "Siguiente",
  "Reg for users 1": "Crea una cuenta",
  "Reg for users 2": "Cuéntanos sobre ti",
  "Reg for users 3": "Finalizar registro",
  "Your last_name": "Tu apellido",
  "Your first_name": "Tu nombre",
  "Your middle_name": "Tu segundo nombre",
  "Your company": "Lugar de trabajo",
  "Your position_in_the_company": "Tu especialidad",
  Back: "Atrás",
  "Min 2": "Al menos 2 caracteres",
  Promo: "Código promocional (si tienes)",
  invitation_1: "De conocidos / colegas",
  invitation_2: "Correo electrónico",
  invitation_3: "Búsqueda en Yandex, Google",
  invitation_4: "Otra fuente",
  invitation_5: "Redes sociales",
  "Where know about platform?": "¿Cómo conociste la plataforma?",
  "Reg finish": "Registrarse",
  regErrorText: "No se pudo registrar al usuario. Verifique los datos",
  "Auth banner text":
    "Inicia sesión para acceder a todas las funciones de la Plataforma",
  "Auth banner text 2":
    "Inicia sesión para aumentar el número de análisis disponibles",
  "Auth banner text 3":
    "Recibe procesamiento gratuito de 10<br/>de tus análisis",
  "Reg error":
    "No se pudo completar el registro debido a un error técnico. Intente nuevamente más tarde",
  "Reg error 400": "El correo electrónico ya está en uso",
  "Rem password": "Ingrese el correo electrónico usado en el registro",
  Phone: "Teléfono",
  "Not valid phone": "Formato de teléfono no válido",
  emailVerify: {
    title: "Confirmación de correo electrónico",
    desc1: "A la dirección de correo ",
    desc2:
      " se ha enviado un correo de confirmación. Haga clic en el enlace para activar su cuenta y acceder al servicio.",
  },
};
